export default __webpack_public_path__ + "icon-action-menu.726a345b.png";